import { render, staticRenderFns } from "./StudyUnitInformation.vue?vue&type=template&id=244e6597&scoped=true&lang=pug&"
import script from "./StudyUnitInformation.vue?vue&type=script&lang=ts&"
export * from "./StudyUnitInformation.vue?vue&type=script&lang=ts&"
import style0 from "./StudyUnitInformation.vue?vue&type=style&index=0&id=244e6597&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244e6597",
  null
  
)

export default component.exports